// extracted by mini-css-extract-plugin
export default {"container":"edit-modal-purchase_container__R5Vjr","image":"edit-modal-purchase_image__rNdLA","content":"edit-modal-purchase_content__fdyle"};